'use strict';

module.exports = require('./lib/extend');



//////////////////
// WEBPACK FOOTER
// ./~/node.extend/index.js
// module id = 1722
// module chunks = 2